import type { TalentTrackingCategory } from "@/lib/talent-tracking-api"

import { BOSS_SEASONS } from "@/core/talent-tracking/seasons.js"
import { memberDisplayLabel } from "@/lib/member-display-label"

export { BOSS_SEASONS as SEASONS } from "@/core/talent-tracking/seasons.js"

export const CATEGORY_LABELS: Record<TalentTrackingCategory, string> = {
  offensive: "Offensive",
  defensive: "Defensive",
  strategic: "Strategic",
}

export const CATEGORY_SHORT_LABELS: Record<TalentTrackingCategory, string> = {
  offensive: "OFF",
  defensive: "DEF",
  strategic: "STR",
}

export const CATEGORY_VALUES = ["offensive", "defensive", "strategic"] as const

export const CATEGORY_ORDER: Record<TalentTrackingCategory, number> = {
  offensive: 0,
  defensive: 1,
  strategic: 2,
}

export const MEMBER_QUERY_DEBOUNCE_MS = 250

export const getMemberDisplayName = (member: {
  displayName: string | null
  userId: string
}): string => {
  return memberDisplayLabel({
    displayName: member.displayName,
    userId: member.userId,
  })
}
